import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { Panel } from '../Panel';

export interface SelectionPanelProps<T> {
  icon?: IconProp;
  iconColor?: string;
  backgroundColor?: string;
  renderIcon?(): React.ReactNode;
  title: string;
  subtitle?: string;
  value: T;

  selected?: boolean;
  onPress?(value: T): void;

  style?: StyleProp<ViewStyle>;
}

export const SelectionPanel = <T,>(props: SelectionPanelProps<T>) => {
  const {
    icon,
    value,
    iconColor,
    backgroundColor,
    title,
    subtitle,
    selected,
    renderIcon,
  } = props;

  const onPress = () => props.onPress?.(value);

  return (
    <StyledPanel selected={selected} style={props.style}>
      <Container onPress={onPress}>
        <IconBox backgroundColor={backgroundColor}>
          {icon ? (
            <FontAwesomeIcon icon={icon} color={iconColor} size={45} />
          ) : renderIcon ? (
            renderIcon()
          ) : null}

          {selected ? (
            <TickContainer>
              <FontAwesomeIcon
                icon="check-circle"
                color={colors.primary[700]}
                size={20}
              />
            </TickContainer>
          ) : null}
        </IconBox>
        <Text variant="h3" weight="semibold">
          {title}
        </Text>
        {subtitle ? <Text>{subtitle}</Text> : null}
      </Container>
    </StyledPanel>
  );
};

const StyledPanel = styled(Panel)<{ selected?: boolean }>`
  border: 2px solid
    ${({ selected }) => (selected ? colors.primary[700] : 'white')};
`;

const Container = styled.TouchableOpacity`
  padding: 10px;
  gap: 10px;
  align-items: center;
`;

const IconBox = styled.View<{ backgroundColor?: string }>`
  height: 103px;
  width: 128px;

  border-radius: 15px;

  align-items: center;
  justify-content: center;

  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor};` : ''}
`;

const TickContainer = styled.View`
  position: absolute;
  top: 5px;
  right: 5px;
`;
